import { render, staticRenderFns } from "./BaseMultiSelectSearch.vue?vue&type=template&id=57c3bd48&"
import script from "./BaseMultiSelectSearch.vue?vue&type=script&lang=ts&"
export * from "./BaseMultiSelectSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports